import { useEffect, useState } from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <Fab
      color="primary"
      size="small"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1200 }}
      aria-label="Back to top"
    >
      <KeyboardArrowUpIcon />
    </Fab>
  );
}

